<div class="modal-body">
  <i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;
  <b>View 5471 Data/Produce Forms</b>
  <br><br>
  <div>
    <table class="table table-bordered text custom-table">
      <thead style="text-align: center">
        <tr>
          <th>LEID</th>
          <th>Tax Code</th>
          <th>Rpt Pd</th>
          <th>BSLA/Business</th>
          <th>Functional Currency</th>
          <th>Legal Entity Name</th>
          <th>Work In Progress Step</th>
        </tr>
      </thead>
      <tbody>
        @for (item of report; track $index) {
<tr>
          <td>{{item.LEID}}</td>
          <td>{{item.tax_code}}</td>
          <td>{{item.rpt_pd}}</td>
          <td>{{item.bsla}}</td>
          <td>{{item.currency}}</td>
          <td>{{item.legal_entity}}</td>
          <td>{{item.work_in_progress}}</td>
        </tr>
}
      </tbody>
    </table>
  </div>
</div>
